import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {FirebaseService} from '../firebase/firebase.service';
import {IUser} from '../../core/interfaces/user';
import {take} from "rxjs/operators";
import {CurrentUserService} from "../current-user/current-user.service";

@Injectable({
  providedIn: 'root'
})
export class UserStatusService {
  currentUserSubscription: Subscription;

  constructor(
    private firebase: FirebaseService,
    private currentUserService: CurrentUserService
  ) {
  }


  setUserOnline() {
    const status = {
      status: 'online',
      lastSeen: ''
    }
    this.currentUserSubscription = this.currentUserService.getCurrentUser().subscribe((user: IUser) => {
      this.firebase.setUserStatus(user.uid, status);
      if (this.currentUserSubscription) {
        this.currentUserSubscription.unsubscribe();
      }
    });
  }

  setUserOffline() {
    const status = {
      status: 'away',
      lastSeen: Date.now()
    }
    return new Observable((observer) => {
      this.currentUserSubscription = this.currentUserService.getCurrentUser().pipe(take(1)).subscribe((user: IUser) => {
        this.firebase.setUserStatus(user.uid, status).then(() => {
          observer.next(user);
          if (this.currentUserSubscription) {
            this.currentUserSubscription.unsubscribe();
          }
        });
      });
    });
  }
}
